import { Box, BoxProps } from "@mui/material";

const Container = ({ children, ...rest }: BoxProps) => {
    return (
        <Box
            maxWidth={{ xs: "unset", lg: "80%" }}
            width={1}
            margin={"0 auto"}
            paddingX={2}
            paddingY={{ xs: 4, sm: 6, md: 8 }}
            {...rest}
        >
            {children}
        </Box>
    );
};

export default Container;
